/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DoctorDocType } from './DoctorDocType';
import {
    DoctorDocTypeFromJSON,
    DoctorDocTypeFromJSONTyped,
    DoctorDocTypeToJSON,
} from './DoctorDocType';
import type { FileSchemaOut } from './FileSchemaOut';
import {
    FileSchemaOutFromJSON,
    FileSchemaOutFromJSONTyped,
    FileSchemaOutToJSON,
} from './FileSchemaOut';

/**
 * 
 * @export
 * @interface DoctorApplicationDocsOut
 */
export interface DoctorApplicationDocsOut {
    /**
     * 
     * @type {string}
     * @memberof DoctorApplicationDocsOut
     */
    id?: string;
    /**
     * 
     * @type {FileSchemaOut}
     * @memberof DoctorApplicationDocsOut
     */
    privateFileId?: FileSchemaOut;
    /**
     * 
     * @type {DoctorDocType}
     * @memberof DoctorApplicationDocsOut
     */
    docType?: DoctorDocType;
}

/**
 * Check if a given object implements the DoctorApplicationDocsOut interface.
 */
export function instanceOfDoctorApplicationDocsOut(value: object): boolean {
    return true;
}

export function DoctorApplicationDocsOutFromJSON(json: any): DoctorApplicationDocsOut {
    return DoctorApplicationDocsOutFromJSONTyped(json, false);
}

export function DoctorApplicationDocsOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoctorApplicationDocsOut {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'privateFileId': json['private_file_id'] == null ? undefined : FileSchemaOutFromJSON(json['private_file_id']),
        'docType': json['doc_type'] == null ? undefined : DoctorDocTypeFromJSON(json['doc_type']),
    };
}

export function DoctorApplicationDocsOutToJSON(value?: DoctorApplicationDocsOut | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'private_file_id': FileSchemaOutToJSON(value['privateFileId']),
        'doc_type': DoctorDocTypeToJSON(value['docType']),
    };
}

